/** @format */

import {SensorGroupsType} from '../types';

/**
 * Вычислит, назначен ли в группы хотя бы один сенсор.
 * @param sensorGroups
 */

const hasSensorGroups = (sensorGroups: SensorGroupsType): boolean => {
  const {red, yellow, gray} = sensorGroups;
  return Boolean(red.length || yellow.length || gray.length);
};

export {hasSensorGroups};
